import { call, put, takeEvery, select, delay } from 'redux-saga/effects';
import * as templateCardActions from '../actions/templateCard';

import { getTemplateByIdRequest } from '../../api/templateCard/getTemplateByIdRequest';
import { createTemplateRequest } from '../../api/templateCard/createTemplateRequest';
import { updateTemplateRequest } from '../../api/templateCard/updateTemplateRequest';
import { deleteTemplateRequest } from '../../api/templateCard/deleteTemplateRequest';

import history from '../../../../common/history';
import { errorProcessing } from '../../../Employees/api/errorProcessing';
import showSuccessWindow from '../../../../common/components/successPopup/successPopup';
import {
  successCreateTemplate,
  successDeleteTemplate,
  successUpdateTemplate,
} from '../../components/TemplateCard/popup/success';
import { SYSTEM_SETTINGS } from '../../../../common/constants/systemUrls';
const getActiveProfileId = state => {
  return (
    state.Authorization &&
    state.Authorization.activeProfile &&
    state.Authorization.activeProfile.profileId
  );
};

function* createTemplateSaga(action) {
  let activeProfileId = yield select(getActiveProfileId);
  if (activeProfileId) {
    try {
      const response = yield call(
        createTemplateRequest,
        activeProfileId,
        action.payload
      );
      yield put(templateCardActions.createTemplateSuccess(response));
      showSuccessWindow(successCreateTemplate(response.name));
      if (action.payload && action.payload.type === 'template')
        history.push('/' + SYSTEM_SETTINGS + '/templates');
    } catch (err) {
      let errData = errorProcessing(err);
      yield put(templateCardActions.createTemplateError(errData));
    }
  } else {
    history.push('/authorization/profiles');
  }
}

function* updateTemplateSaga(action) {
  let activeProfileId = yield select(getActiveProfileId);
  if (activeProfileId) {
    try {
      const response = yield call(
        updateTemplateRequest,
        activeProfileId,
        action.payload
      );
      yield put(templateCardActions.updateTemplateSuccess(response));
      showSuccessWindow(successUpdateTemplate(response.name));
      history.push('/' + SYSTEM_SETTINGS + '/templates');
    } catch (err) {
      let errData = errorProcessing(err);
      yield put(templateCardActions.updateTemplateError(errData));
    }
  } else {
    history.push('/authorization/profiles');
  }
}

function* deleteTemplateSaga(action) {
  let activeProfileId = yield select(getActiveProfileId);
  if (activeProfileId) {
    try {
      const response = yield call(
        deleteTemplateRequest,
        activeProfileId,
        action.payload
      );
      if (response.success) {
        showSuccessWindow(successDeleteTemplate(action.payload));
        yield put(templateCardActions.deleteTemplateSuccess(response));
      }
      history.push('/' + SYSTEM_SETTINGS + '/templates');
    } catch (err) {
      let errData = errorProcessing(err);
      yield put(templateCardActions.deleteTemplateError(errData));
    }
  } else {
    history.push('/authorization/profiles');
  }
}

function* getTemplateByIdSaga(action) {
  let activeProfileId = yield select(getActiveProfileId);
  if (activeProfileId) {
    try {
      let { payload } = action;
      const response = yield call(
        getTemplateByIdRequest,
        activeProfileId,
        payload
      );
      yield put(templateCardActions.getTemplateByIdSuccess(response));
    } catch (e) {
      yield put(templateCardActions.getTemplateByIdFailure(errorProcessing(e)));
    }
  } else {
    yield delay(500);
    activeProfileId = yield select(getActiveProfileId);
    activeProfileId
      ? yield put(templateCardActions.getTemplateById(action.payload))
      : history.push('/authorization/profiles');
  }
}

export function* templateCardWatcher() {
  yield takeEvery(
    templateCardActions.getTemplateById.toString(),
    getTemplateByIdSaga
  );
  yield takeEvery(
    templateCardActions.createTemplate.toString(),
    createTemplateSaga
  );
  yield takeEvery(
    templateCardActions.updateTemplate.toString(),
    updateTemplateSaga
  );
  yield takeEvery(
    templateCardActions.deleteTemplate.toString(),
    deleteTemplateSaga
  );
}
